export default __webpack_public_path__ + "static/media/xDAI-icon.50f18fa0.svg";